import messages from '../locales/lt_LT.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'lt-LT',
};
export default lang;
